// Libs
import React from 'react';
import { Empty } from 'antd';
import VirtualizedList from '../../../Lists/VirtualizedList';
import { getInventorySeriesReconciliationHistory } from '../../../Lists/cards/Warehouses/InventorySeriesReconciliationHistory';

export default function SerieHistoryModal(props) {
	const { serieHistory, sendToast, modeView } = props;
	const getRowHeight = ({ index }) => {
		const audit = getInventorySeriesReconciliationHistory(
			serieHistory.data[index]?.inventory_series_reconciliation,
		);
		if (!audit) return 190;
		return Math.min(850, 520 + Math.ceil(audit.reason.length / 70) * 18);
	};

	return (
		<div className='container-info-orders-income'>
			{serieHistory.data.length === 0 ? (
				<Empty />
			) : (
				<VirtualizedList
					cardId='serieHistoryCard'
					interpolatedRowStyle
					listStyle={{
						height: document.documentElement.clientHeight * 0.66,
						width:
							modeView === 'table'
								? 520
								: document.documentElement.clientWidth * 0.98,
					}}
					rowHeight={getRowHeight}
					rows={serieHistory.data}
					isSpinning={false}
					customProps={{
						sendToast,
					}}
				/>
			)}
		</div>
	);
}
